import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { formatCustomTargetWeightPercent, isKpiOnTrack, shouldShowCustomTargetWeight } from '~/functions/impact-carry-kpi';
import { diffMetricAssignment } from '~/functions/review-snapshot-diff';
export default /*#__PURE__*/_defineComponent({
  __name: 'ImpactCarryKpiSection',
  props: {
    metricAssignment: null,
    onTrackLabel: null,
    behindLabel: null,
    showKpiWeight: {
      type: Boolean
    },
    exportLayout: {
      type: Boolean
    },
    compareToLive: {
      type: Boolean
    },
    compareMetricAssignment: null,
    compareReviewTimeIsDisplay: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var assignmentDiffChanges = computed(function () {
      if (!props.compareToLive || !props.compareMetricAssignment) return [];
      var reviewTime = props.compareReviewTimeIsDisplay ? props.metricAssignment : props.compareMetricAssignment;
      var current = props.compareReviewTimeIsDisplay ? props.compareMetricAssignment : props.metricAssignment;
      return diffMetricAssignment(reviewTime, current);
    });
    var showAssignmentDiff = computed(function () {
      return assignmentDiffChanges.value.length > 0;
    });
    var diffKeyLabels = computed(function () {
      return {
        comment: String(proxy.$t('comment')),
        customTargetWeight: String(proxy.$t('customTargetWeight'))
      };
    });
    var trackStatus = computed(function () {
      return isKpiOnTrack(props.metricAssignment);
    });
    var statusChipLabel = computed(function () {
      if (trackStatus.value === null) return null;
      return trackStatus.value ? props.onTrackLabel : props.behindLabel;
    });
    var statusChipColor = computed(function () {
      if (trackStatus.value === null) return null;
      return trackStatus.value ? 'success' : 'danger';
    });
    var weightLabel = computed(function () {
      if (!props.showKpiWeight) return null;
      var raw = props.metricAssignment.customTargetWeight;
      if (!shouldShowCustomTargetWeight(raw, true)) return null;
      var percent = formatCustomTargetWeightPercent(raw);
      if (percent === null) return null;
      return String(proxy.$t('weight', {
        percent: percent
      }));
    });
    var assignmentRemark = computed(function () {
      var _props$metricAssignme;
      var text = (_props$metricAssignme = props.metricAssignment.comment) === null || _props$metricAssignme === void 0 ? void 0 : _props$metricAssignme.trim();
      return text || null;
    });
    return {
      __sfc: true,
      props: props,
      proxy: proxy,
      assignmentDiffChanges: assignmentDiffChanges,
      showAssignmentDiff: showAssignmentDiff,
      diffKeyLabels: diffKeyLabels,
      trackStatus: trackStatus,
      statusChipLabel: statusChipLabel,
      statusChipColor: statusChipColor,
      weightLabel: weightLabel,
      assignmentRemark: assignmentRemark
    };
  }
});